// Standard library imports
import React from 'react';
// External library imports
import { Form, Formik } from 'formik';
import { get as lodashGet } from 'lodash';

// Internal module imports
import Table from '../../../../../components/Table/Table';
import TabsComponent from '../../../../../components/Tabs/Tabs';
import { TextArea } from '../../../../../components/Inputs/Input';
import AllDeviceCss from '../../../../../styles/AllDevices.module.css';
import bidClasses from '../../Bidding.module.css';

const getCapacityPriceData = (request = {}, market) => {
    const { capacity = [], price = [], regulationPrice = [] } = request;
    const data = capacity.map((cap, idx) => {
        const slot = idx + 1;
        return {
            slot,
            hour: `${idx}-${slot}`,
            price: lodashGet(price, [idx]),
            capacity: cap,
            ...(market.includes('aFRR') || market.includes('mFRR') ? { regulationPrice: lodashGet(regulationPrice, [idx]) } : {}),
        };
    });
    return data;
};

const RequestOverview = ({ market, request, setOpen }) => {
    const capacityPriceData = getCapacityPriceData(request, market);
    const tableHeaders = ['Slot', 'Hour', 'Capacity', 'Price'];
    const tableKey = ['slot', 'hour', 'capacity', 'price'];

    if (market.includes('aFRR') || market.includes('mFRR')) {
        tableHeaders.push('Energy Price');
        tableKey.push('regulationPrice');
    }
    const tabs = [
        {
            name: 'Capacity/Price',
            component: (
                <div>
                    <Table head={tableHeaders} keys={tableKey} data={capacityPriceData} />
                    <div>
                        <Formik
                            initialValues={{
                                note: request?.note || '',
                            }}
                            enableReinitialize
                        >
                            {({}) => (
                                <Form>
                                    <div className={AllDeviceCss.FieldControl2}>
                                        <label for="note">Note</label>
                                        <TextArea name={`note`} label="Note" disabled={true} />
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            ),
        },
    ];
    return (
        <div className={bidClasses.LogsModalContainer}>
            <TabsComponent tabs={tabs} />
            <div className={AllDeviceCss.ButtonContainer}>
                <div className="btn-secondary" onClick={() => setOpen({ status: false, request: null })}>
                    Close
                </div>
            </div>
        </div>
    );
};

export default RequestOverview;
